<template>
  <div class="food-manage">
    <div class="food-search tuolele-main-box">
      <div class="tuolele-main-search tuolele-main-search-item">
        积分总值: {{ point_value }}
      </div>
    </div>
    <div class="tuolele-main-box">
      <el-table :key="tableKey" :data="lists" border stripe>
        <el-table-column label="时间" prop="create_time" align="center" />
        <el-table-column label="积分变动" prop="occur_score" align="center" />
        <el-table-column label="业务来源" prop="type_name" align="center" />
        <el-table-column label="变动原因" prop="content" align="center" />
        <el-table-column label="操作人" prop="editor_name" align="center" />
      </el-table>
    </div>
    <div class="footer pagination-footer" style="text-align: center;">
      <el-pagination layout="prev, pager, next, slot, jumper" :current-page.sync="listQuery.p" prev-text="上一页" next-text="下一页" :total="listQuery.total" :page-size="listQuery.limit" @current-change="fnGetScoreLists" />
    </div>
  </div>
</template>
<script>

export default {
  name: 'TiYouYouScoreList',
  data() {
    return {
      lists: [],
      tableKey: 0,
      listQuery: {
        p: 1,
        limit: 20,
        sub_id: ''
      },
      point_value: ''
    }
  },
  created() {
    this.listQuery.sub_id = this.$route.query.sub_id
    this.fnGetScoreLists()
  },
  methods: {
    fnGetScoreLists: function() {
      this.$http.tyyPointNote(this.listQuery).then(res => {
        this.listQuery.total = parseInt(res.data.count)
        this.lists = res.data.list
        this.point_value = res.data.point_value
      })
    }
  }
}
</script>
<style lang="scss">
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
